import { motion } from 'motion/react';
import { HealthDataEditorTitleMobile } from './health-data-editor-title-mobile';
import { LastUpdatedTag } from './last-updated-tag';

export function HealthDataEditorHeaderMobile() {
  return (
    <motion.div
      className="relative z-10 px-4 pt-4 pb-6"
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, ease: 'easeOut' }}
    >
      <div className="flex flex-col gap-2.5">
        <LastUpdatedTag/>

        {/* Main Content */}
        <div className="flex flex-col gap-4">
          <HealthDataEditorTitleMobile/>
        </div>
      </div>
    </motion.div>
  );
}
